let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7oEN8")).then(() => parcelRequire('btcGb'));